module.exports = __webpack_public_path__ + "static/fonts/Gilroy-Regular.93a118ae.otf";